import { useCallback } from 'react';
import { getNaverLogin, SNS_AUTH_DATA_KEY } from 'app/libs/snsUtils';
import { setSessionItem } from 'app/libs/storageUtils';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';

export default function useAuthNaver() {
	const ua = useSsrUserAgent();

	/**
	 * 함수 호출시 아래와 같은 타입으로 파라미터를 전달해야 합니다.
	 * snsAuthorizeForTypes.LOGIN,
	 * snsAuthorizeForTypes.MY_INFO_ACCESS,
	 * snsAuthorizeForTypes.CONNECT_LOGIN
	 */
	const authorizeNaver = useCallback(
		async (type, options, reauthenticate = false) => {
			if (!type) throw new Error('인증 타입을 전달해 주세요.');

			try {
				const naverLogin = await getNaverLogin();
				setSessionItem(SNS_AUTH_DATA_KEY, { type, state: naverLogin.state, options });

				// 세션 존재 여부 상관없이 모두 재인증
				if (!ua().isPc) {
					window.location.href = `${naverLogin.generateAuthorizeUrl()}${reauthenticate ? '&auth_type=reauthenticate' : ''}`;
				} else {
					// 자동 resize를 막기위한 파라미터
					window.location.href = `${naverLogin.generateAuthorizeUrl()}&svctype=0${reauthenticate ? '&auth_type=reauthenticate' : ''}`;
				}
			} catch (err) {
				console.error(err);
			}
		},
		[ua],
	);

	return { authorizeNaver };
}
